import React from 'react'

const Dashboard = ({ message, objetosTexto, laberintoObjects, appSize} ) => {

    const dashboardSize = {
        width: appSize[0] > appSize[1] ? `${ ( appSize[0]* 0.9 ) - appSize[1] * 0.85 }px` : '95%',
        fontSize: appSize[0] < appSize[1] ? `1.75vh` : `1.75vw`,
        padding: appSize[0] < appSize[1] ? `1vh` : `1vw`,
    }

    const objetosStyle = {
        padding: appSize[0] < appSize[1] ? `1vh` : `1vw`,
        borderRadius: appSize[0] < appSize[1] ? `2vh` : `2vw`,
        minHeight: appSize[0] < appSize[1] ? `25vh` : `25vw`,
    }

  return (
    <div className='dashboard-container' style={ dashboardSize }>
        <div className='instrucciones-container'>
            { message }
        </div>
        <div className='objetos-container' style={ objetosStyle }>
            <div className='objetos-title'> { objetosTexto } </div>
            <div className='objetos-list'>
                <ul>
                    { laberintoObjects.map((valor, index) => (
                        <li key={ index }>{ valor }</li>
                    ))}
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Dashboard